import React from 'react';

import { type ThirdPartyConfigsBootstrap } from '../../../constants/schemas/3p-config';
import { BannerPlacement, type useOAuthHandlers } from '../banner-placement';

interface SearchPageResultsInlineBannerPlacementProps {
	thirdPartyConfigs: ThirdPartyConfigsBootstrap;
	availableProductsOrder: string[]; // Product keys in display order; connectors will be shown in this order
	useOAuthHandlers: useOAuthHandlers;
	onMessageViewed?: (trackImpression: () => void) => void;
}

export const SearchPageResultsInlineBannerPlacement = ({
	thirdPartyConfigs,
	availableProductsOrder,
	useOAuthHandlers,
	onMessageViewed,
}: SearchPageResultsInlineBannerPlacementProps): React.JSX.Element | null => {
	return (
		<BannerPlacement
			placementId="search-page-results-inline"
			thirdPartyConfigs={thirdPartyConfigs}
			availableProductsOrder={availableProductsOrder}
			useOAuthHandlers={useOAuthHandlers}
			onMessageViewed={onMessageViewed}
		/>
	);
};
